import React from "react";
import Typography from "@material-ui/core/Typography";
const OperationLifeCycle = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Operation Life Cycle
      </Typography>
      <Typography paragraph variant="h5">
        Collaborate with the team to process orders
      </Typography>
      <Typography paragraph variant="body1">
        Operation Life Cycle is one of the features under the Inventory module
        to perform operation transactions particularly to manage and track the
        order fulfillment cycle from preparing the product ordered until it is
        ready to be send to customers. It contains any information regarding the
        current status of the process order, the product deliverable deadline,
        and the responsinble person to fulfill the customer order.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Operation Life
        Cycle list. It is displayed like a set of cards in each container
        representing the Operation Life Cycle steps. The data that appear on
        each card consist of Operation Card Title, Customer Name, Delivery
        Estimation, Responsible Warehouse, Deadline Date, Operation Card Created
        Date, and Operation Card Assignment.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 2 buttons that appear on each card of Operation Life
        Cycle data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Operation Card</b>
        <br />
        This button only appears if the Operation Card position is not in
        'Finished'. It is used to edit the Operation Card data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Operation Card Detail</b>
        <br />
        This button is used to navigate to the Operation Card detail which
        contains some tabs with details below:
        <ul>
          <li>
            <b>Operation Card</b> : This tab is to display the Operation Card
            data.
          </li>
          <li>
            <b>Dashboard</b> : This tab is to display any Dashboard related to
            the Operation Card.
          </li>
          <li>
            <b>Operation</b> : This tab is to display any Operation Item related
            to the Operation Card.
          </li>
          <li>
            <b>Delivery</b> : This tab is to display any Delivery related to the
            Operation Card.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Operation Card.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Operation Card.
          </li>
        </ul>
      </Typography>
    </React.Fragment>
  );
};

export default OperationLifeCycle;
